import UiDuniaBaseForm from '@/forms/components/ui-dunia/base-form';
import UiDuniaBaseStep from '@/forms/components/ui-dunia/base-step';
import UiDuniaBaseStepNbc from '@/forms/components/ui-dunia/base-step-nbc';
import UiDuniaBaseStepLogin from '@/forms/components/ui-dunia/base-step-login';
//import UiDuniaBaseStepWelcome from '@/forms/components/ui-dunia/base-step-welcome';
import UiDuniaProfileStep from '@/forms/components/ui-dunia/base-step-personal-info';
import UiDuniaBaseField from '@/forms/components/ui-dunia/base-field';
import UiDuniaBaseFieldset from '@/forms/components/ui-dunia/base-fieldset';
import UiDuniaNoticeFieldset from '@/forms/components/ui-dunia/notice-fieldset';
import ModalAndEndPage from '@/forms/components/shared/modal-and-end-page-wrapper';
import ModalAndEndPageDigital from '@/forms/components/cards/credit-card-digital/modal-and-end-page-digital-wrapper';
import router from '@/router';
import flowManager from '@/lib/services/flow-manager';
import modelStore from '@/lib/services/models-store';
import modalService from '@/lib/services/modal-service';
import resetService from '@/lib/helpers/reset-service';
import DuniaLogicCallbacks from '@/forms/models/dunia-logic-callbacks';
import DuniaLogicCallbacksDigital from '@/forms/models/dunia-logic-callbacks-digital';
import transactionService from '@/forms/api/services/transaction';
import incomeUpdateService from '@/forms/api/services/income-update';
import wokEmailValidationServive from '@/forms/api/services/work-email-validate';
import creditScoreCalculationService from '@/forms/api/services/creidt-score-calculation';
import decisionService from '@/forms/api/services/decision';
import srCreateService from '@/forms/api/services/sr-create';
import branchDetailsService from "@/forms/api/services/branch-details";
import store from '@/store';

import * as conditions from '@/forms/conditions';
import getValueByFieldName from '@/forms/helpers/get-value-by-field-name';
import getValueFromCookie from '@/forms/helpers/get-value-from-cookie';
import FORM_NAMES from '@/forms/constants/form-names';
import {
    START_TRANSACTION,
    END_TRANSACTION,
    OTP_VALIDATE,
    SERVICE_STATUS,
} from '@/forms/constants/services';

import {
    RESET_TRANSACTION_DECISION,
    SET_CURRENT_PRODUCT,
    SET_SERVICE_ERROR,
    SET_CARD_TYPE,
    SET_BANK_NAME,
} from '@/lib/constants/mutations';

import STEP_NAMES from '@/forms/constants/step-names';
import FIELDSET_NAMES from '@/forms/constants/fieldset-names';
import FIELD_NAMES from '@/forms/constants/field-names';
import BRAND from '@/forms/constants/brand';

import {
    EMAIL_VALIDATION_PATTERN,
    NAMES_CHARS,
    EMIRATES_NUMBER_LENGTH,
    RESET_UPLOADS_BUTTON,
    END_FORM,
    COUNTRIES,
    COUNTRIESAPPOINTMENT,
    EMIRATE_LIST,
    //EMIRATE_LIST_LOAN,
    EMIRATE_LIST_CARD,
    MAPPED_PHONE_CODE,
    NOT_VALID_OTP_MESSAGE,
    EMIRATES_STARTING_NUMBER,
    DIGIT_CHARS,
    ALPHA_NUMERIC,
    MONTHLY_INSTALMENTS_OPTIONS,
    INDUSTRY_TYPES,
    CAPTCHA_LENGTH,
    CAPTCHA_CHARS,
    ADDRESS_CHARS,
    IS_VALID_DATE
} from '@/forms/constants/onboarding-logic';

// Services
import institutionsService from '@/forms/api/services/institutions';
import { companiesRepository } from '@/forms/api/repository-factory';
import getBanksService from '@/forms/api/services/get-bank-names';
import {
    FORM_TYPE,
} from '@/lib/constants/model-types';

// Helpers
import formatMatchedString from '@dunia/ui/src/core/helpers/suggest-format-matched-string-suggestion';
import checkServiceStatus from '@/lib/helpers/check-service-status';
import conditionFromStore from '@/forms/helpers/condition-from-store';

const createLogicCallbacks = duniaFormComponent => new DuniaLogicCallbacks({

    onServiceErrorCallback: (error) => {
        duniaFormComponent.showModalOverlay(error);

    },
    onServiceCallback: () => {},
    finishCallback: () => duniaFormComponent.finishCallback(),
    onConditionFailedCallback: (reasonToStay) => {

        duniaFormComponent.showEndPage(reasonToStay);
    },
});
const createLogicCallbacksDigital = duniaFormComponent => new DuniaLogicCallbacksDigital({

    onServiceErrorCallback: (error) => {
        duniaFormComponent.showModalOverlay(error);

    },
    onServiceCallback: () => {},
    finishCallback: () => duniaFormComponent.finishCallback(),
    onConditionFailedCallback: (reasonToStay) => {

        duniaFormComponent.showEndPage(reasonToStay);
    },
});

const mixin = {
    props: {
        product: {
            type: String,
        },

    },

    methods: {
        ...conditions,
        formatMatchedString,
        getValueFromCookie,
        conditionFromStore,

        async getCountries(search) {
            let countries = COUNTRIES;

            countries = countries.filter((country) => {
                const label = country.label.toLowerCase();
                const term = search.toLowerCase();
                return label.indexOf(term) > -1;
            });

            return countries;
        },
        async getCountriesAppointment(search) {
            let countries = COUNTRIESAPPOINTMENT;

            countries = countries.filter((country) => {
                const label = country.label.toLowerCase();
                const term = search.toLowerCase();
                return label.indexOf(term) > -1;
            });

            return countries;
        },
        async getCompanies(search) {
            let response = [];
            try {
                response = await companiesRepository.getCompanies(search);
            } catch (err) {
                const error = 'An error occurred while processing your request';
                this.serviceError = error;
            }

            return response.data
                .map(company => ({ value: company.EMPLOYER_NAME, label: company.EMPLOYER_NAME }));
        },

        async getInstitutions(search) {
            let response = [];
            try {
                response = await institutionsService.searchInstitutions(search);

            } catch (err) {
                const error = 'An error occurred while processing your request';
                this.serviceError = error;
            }
            return response.data.map(
                institution => ({ value: institution.id, label: institution.name }),
            );
        },
        async getBanksForBt(search) {
            let response = [];
            try {
                response = await getBanksService.getBankNames(search);


            } catch (err) {
                const error = 'An error occurred while processing your request';
                this.serviceError = error;
            }
            return response.data.map(
                banks => ({ value: banks['bank-code'], label: banks['bank-name'] }),
            );
        },
        async getBranchCodes() {
            let response = [];
            try {
                response = await branchDetailsService.getBranchDetails();

            } catch (err) {
                const error = 'An error occurred while processing your request';
                this.serviceError = error;
            }
            return response.data.map(
                branches => ({ value: branches.value, label: branches.value }),
            );
        },

        finishCallback() {
            this.showEndPage({
                title: 'Great!✌️ Now you can access to your account and start using you brand new Platinum card!',
            }, );
        },

        showEndPage({
            title,
            subtitle = '',
            actions = [],
            actionNameEndForm = null,
            actionNameEndFormRejected = null,
            name = 'thanks',
        }) {
            router.goToEndPage(name, { stopGoBack: true });

            let mappedEndPageActions = [];

            if (actionNameEndForm) {
                mappedEndPageActions = [{
                    click: this.goToLastVisitedPage,
                    label: actionNameEndForm,
                }, ];
            }
            if (actionNameEndFormRejected) {
                mappedEndPageActions = [{
                    click: window.location.href =
                        "https://www.deem.io?utm_source=RejectTY&utm_medium=Button&utm_campaign=LoanApp",
                    label: actionNameEndFormRejected,
                }, ];
            } else {
                mappedEndPageActions = actions.map((action) => {
                    if (action.click === END_FORM) {
                        return {
                            click: this.goToLastVisitedPage,
                            label: action.label,
                        };
                    }
                    return action;
                });
            }

            this.endPageData.title = title;
            this.endPageData.subtitle = subtitle;
            this.endPageData.actions = mappedEndPageActions;
        },

        goToLastVisitedPage() {
            router.goToLastVisitedPage();
        },

        goToForm(name, title) {
            this.$store.commit(SET_CARD_TYPE, { cardType: title })
            router.goToFormByName(name);
        },

        goToStep(stepName) {
            return () => flowManager.goToStep(stepName);
        },

        goToNextStep() {
            flowManager.goToNextStep();
        },

        goToNextStepWithoutValidate() {
            flowManager.goToNextStep({ skipValidations: true });
        },

        doItLaterNextStepWithoutValidate() {
            this.$store.state.statementOneData = null;
            this.$store.state.statementTwoData = null;
            this.$store.state.statementThreeData = null;
            this.$store.state.isPerfiosError = null;
            this.$store.state.perfiosErrorMessage = null;
            //this.$store.state.perfiosErrorMessage = null;
            //  wokEmailValidationServive.workEmailValidate
            // transactionService.completeTransaction
            // decisionService.isUserAllowed
            incomeUpdateService.incomeUpdate;
            srCreateService.srCreate;
            creditScoreCalculationService.creditScoreCalculation;
            //flowManager.goToNextStep();
            flowManager.goToNextStep({ skipValidations: true });

        },

        doItLaterIBAN() {
            flowManager.goToNextStep({ skipValidations: true });
        },

        doItLaterNeedsReview() {
            flowManager.goToNextStep({ skipValidations: true });
        },
        showModalOverlay(error) {

            this.$store.commit(SET_SERVICE_ERROR, { serviceError: error })
            modalService.setData({
                title: 'Oops',
                content: `😞 ${error}`,
                actions: [{
                    label: 'Try Again',
                    click: async() => {
                        router.hideModalOverlay();
                        await flowManager.goToNextStep();
                    },
                }, ],
            });
            router.showModalOverlay();
        },

        fieldValues(fieldname) {
            const { $store } = this;

            return getValueByFieldName($store.state.formData.values, fieldname);
        },

        suffixSingularPlural(name, suffix) {
            return parseInt(this.fieldValues(name) || 1, 10) === 1 ? suffix : `${suffix}s`;
        },

        resetTransactionServiceAndFields(fields, callApi = false) {

            return async() => {
                this.resetTransactionServices();

                if (callApi) {

                    await transactionService.startTransaction(
                        flowManager.currentStep,
                        flowManager.logicCallbacks,
                    );
                }

                this.resetFields(fields)();
            };


        },

        resetOTPServiceAndFields() {
            return async() => {
                resetService(OTP_VALIDATE);
                this.resetFields([FIELD_NAMES.OTPCode])();
            };
        },

        resetFields(fieldNames) {
            return () => {
                fieldNames.forEach((fieldName) => {
                    const field = this.getField(fieldName);
                    if (field) {
                        field.onChange(null, { resetValidationsIfEmpty: true });
                    }
                });
            };
        },

        getField(fieldName, { allFields } = {}) {
            const mainForm = modelStore.modelForName(
                FORM_TYPE,
                this.$store.state.formData.mainFormName,
            );

            if (allFields) {
                return mainForm.getFieldEvenNotPresent(fieldName);
            }

            return mainForm.getField(fieldName);
        },

        fieldsHaveValue(names) {
            return names
                .reduce((acc, fieldName) => (this.fieldValues(fieldName) !== null) || acc, false);
        },

        resetUploadsButtonText(fieldNames) {
            if (this.fieldsHaveValue(fieldNames)) {
                return this.RESET_UPLOADS_BUTTON;
            }
            return null;
        },

        productIs(prod) {
            return this.product === prod;
        },

        resetTransactionServices() {
            //this.$store.commit(RESET_TRANSACTION_DECISION);
            //resetService(START_TRANSACTION);
            //resetService(END_TRANSACTION);
            this.$store.state.statementOneData = null;
            this.$store.state.statementTwoData = null;
            this.$store.state.statementThreeData = null;
            this.$store.state.isPerfiosError = null;
            this.$store.state.perfiosErrorMessage = null;
        },

        saveCurrentProduct() {
            const { product } = this;
            this.$store.commit(SET_CURRENT_PRODUCT, { product });
        },
    },

    data: () => ({
        serviceError: null,
        endPageData: {
            title: '',
            subtitle: '',
            actions: {},
        },
        FORM_NAMES,
        STEP_NAMES,
        FIELDSET_NAMES,
        FIELD_NAMES,
        BRAND,
        RESET_UPLOADS_BUTTON,
        EMIRATE_LIST,
        INDUSTRY_TYPES,
        CAPTCHA_LENGTH,
        CAPTCHA_CHARS,
        //EMIRATE_LIST_LOAN,
        EMIRATE_LIST_CARD,
        EMIRATES_NUMBER_LENGTH,
        EMAIL_VALIDATION_PATTERN,
        NAMES_CHARS,
        ALPHA_NUMERIC,
        NOT_VALID_OTP_MESSAGE,
        OTP_VALIDATE,
        EMIRATES_STARTING_NUMBER,
        MONTHLY_INSTALMENTS_OPTIONS,
        ADDRESS_CHARS,
        IS_VALID_DATE,
        GENDER: [{
                value: 'F',
                label: 'Female',
            },
            {
                value: 'M',
                label: 'Male',
            },
        ],
        MARITAL_STATUS: [{
                value: 'Single',
                label: 'Single',
            },
            {
                value: 'Married',
                label: 'Married',
            },
        ],
        PAYMENT_HOLIDAY_STATUS: [{
                value: 'Yes',
                label: 'Yes',
            },
            {
                value: 'No',
                label: 'No',
            },
        ],
        residenceTypes: [{
                label: 'House owned by you',
                value: 'HOUSE OWNED BY ME',
            },
            {
                label: 'House rented in your name',
                value: 'HOUSE RENTED IN MY NAME',
            },
            {
                label: 'House shared with others',
                value: 'HOUSE SHARED WITH OTHERS',
            },
            {
                label: 'House provided by your company',
                value: 'HOUSE PROVIDED BY MY COMPANY',
            },
        ],
        MAPPED_PHONE_CODE,
    }),

    computed: {
        isOnStep() {
            return router.isOnStep;
        },

        isOnEndPage() {
            return router.isOnEndPage;
        },

        isOnModal() {
            return router.isOnModal;
        },

        uiForm() {
            return UiDuniaBaseForm;
        },

        uiBaseStep() {
            return UiDuniaBaseStep;
        },

        uiBaseNbc() {
            return UiDuniaBaseStepNbc;
        },
        uiBaseLogin() {
            return UiDuniaBaseStepLogin;
        },
        // uiBaseWelcome() {
        //   return UiDuniaBaseStepWelcome;
        // },
        uiBasePersonal() {
            return UiDuniaProfileStep;
        },

        uiBaseFieldset() {
            return UiDuniaBaseFieldset;
        },

        uiNoticeFieldset() {
            return UiDuniaNoticeFieldset;
        },

        uiBaseField() {
            return UiDuniaBaseField;
        },

        uiModalAndEndPage() {
            return ModalAndEndPage;
        },
        uiModalAndEndPageDigital() {
            return ModalAndEndPageDigital;
        },

        getLogicCallback() {
            return createLogicCallbacks(this);
        },
        getLogicCallbackDigital() {
            return createLogicCallbacksDigital(this);
        },

        userName() {
            return this.fieldValues(FIELD_NAMES.firstName) || '';
        },

        hasUploadedIDCard() {
            const { $store } = this;
            return $store.state.formData.OCRUpdatedFields;
        },

        isValidOTP() {
            const result = checkServiceStatus(OTP_VALIDATE);
            return result === SERVICE_STATUS.success;
        },

        isCompanyListed() {
            const companyData = this.$store.state.formData.values[FIELD_NAMES.companyName];
            if (companyData) {
                return !companyData.other;
            }
            return false;
        },
        //Bigin Enhancement by Attra
        monthlyInstalmentOptions() {
            return this.$store.state.formData.monthlyInstalmentsOptions;
        },
        getApprovedLimit() {
            return this.$store.state.preScreendedAmount;
        },
        getCifNumber() {
            return this.$store.state.cifnumber;
        },
        getRiskFlag() {
            var riskflag = this.$store.state.creditScoreCalculationRes;
            return this.$store.state.creditScoreCalculationRes['risk-flag'];
        },
        getCreistScoreCalculationStatus() {
            return this.$store.state.creditScoreCalculationSatus;
        },
        getAppianStatus() {
            return this.$store.state.appianIncomeInfo;
        },
        getAppianPrescreened() {
            return this.$store.state.stpPreScreenedAmount;
        },

        getLastThreeMonths() {
            let today = new Date();
            let month = today.getMonth();

            let Currentyear = today.getFullYear();
            let currentYearString = '' + Currentyear + '';
            currentYearString = currentYearString.substring(2, 4);
            let lastYear = today.getFullYear() - 1;
            let lastYearString = '' + lastYear + '';
            lastYearString = lastYearString.substring(2, 4);
            let monthNames = ["January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
            ];
            if (month === 0) {
                return monthNames[9] + '’' + lastYearString + '/' + monthNames[10] +
                    '’' + lastYearString + '/' + monthNames[11] + '’' + lastYearString;
            } else if (month === 1) {
                return monthNames[10] + '’' + lastYearString + '/' + monthNames[11] +
                    '’' + lastYearString + '/' + monthNames[0] + '’' + currentYearString;
            } else if (month === 2) {
                return monthNames[11] + '’' + lastYearString + '/' + monthNames[0] +
                    '’' + currentYearString + '/' + monthNames[1] + '’' + currentYearString;
            } else {
                return monthNames[month - 3] + '’' + currentYearString + '/' + monthNames[month - 2] +
                    '’' + currentYearString + '/' + monthNames[month - 1] + '’' + currentYearString;
            }
        },

        installmentPeriod() {
            return this.fieldValues(FIELD_NAMES.instalmentsAmount)
        },
        getBankName() {
            let bankName = this.$store.state.institutions.find(obj => {
                return obj.id === this.fieldValues(FIELD_NAMES.bankAccount)
            })


            if (typeof bankName !== 'undefined') {
                this.$store.commit(SET_BANK_NAME, { bankName: bankName.name })
                return bankName.name;
            }
        },
        getIBANScreen() {

            // const { $store } = this;
            const { $store } = this
            return $store.state.appianEmpInfo


        },
        getUTMFromQueryStrings() {
            var queryStringObj = JSON.parse(JSON.stringify(this.$store.state.querystrings));
            return queryStringObj;
        },
        getMonthlyInstalment() {
            const { $store } = this;
            return $store.state.monthlyInstalment;;
        },
        getUploadStatementOneData() {


            const { $store } = this;
            return $store.state.statementOneData;
        },
        getUploadStatementTwoData() {
            const { $store } = this;
            return $store.state.statementTwoData;
        },
        getUploadStatementThreeData() {
            const { $store } = this;
            return $store.state.statementThreeData;
        },
        getPromoCodeResponse() {
            const { $store } = this;
            return $store.state.promoCodeResponse;
        },
        //End Enhancement by Attra
    },

    updated() {
        if (this.serviceError) {
            window.setTimeout(() => {
                this.serviceError = null;
            }, 3000);
        }
    },

    mounted() {
        this.saveCurrentProduct();
    },
};

export default mixin;